/**
 * @param prevSearch - an existing search params string
 * @param paramUpdates - an array of {@link URLSearchParam} objects. Each one represents an update
 * to be applied to the search string. If an update has `update.value: null`, that update will be
 * deleted from the returned string. `encodeURIComponent` is used to encode each value.
 * @returns the updated search string
 */
export const updateURLSearchParams = (
    prevSearch: string,
    paramUpdates: URLSearchParam[],
): string => {
    const oldSearch = new URLSearchParams(prevSearch);
    const newSearch = new URLSearchParams(prevSearch);

    paramUpdates.forEach(({ key, value }: URLSearchParam): void => {
        if (value === null) {
            newSearch.delete(key);
        } else if (oldSearch.get(key) !== value) {
            newSearch.set(key, encodeURIComponent(value));
        }
    });

    return newSearch.toString();
};
